import Radio from "components/Input/Radio";
import Banner from "components/UI/molecules/Banner";
import React from "react";
import BrowseWrapper from "components/UI/organisms/BrowseWrapper";
import { FILTER_TYPES } from "helpers/hooks/useFilters";
import { useEffect, useState } from "react";
import { isTrue } from "helpers/utils/validators";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "pages/layouts/dashboard";
import useOrganization from "store/organization/service-hook";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";
import ModalLayout from "components/Modal";
import GetAddonsButton from "components/UI/molecules/GetAddonsButton";
import Button from "components/Button";
import useRedirect from "helpers/hooks/useRedirect";
import SearchInput from "components/UI/molecules/SearchInput";
import { useBrowseNavigate } from "../utils";

export const browse_options = [
  {
    id: 1,
    title: `Browse`,
    pageTitle: "Browse",
  },
  {
    id: 2,
    title: `Saved Careers`,
    pageTitle: "Saved Careers",
  },
  {
    id: 3,
    title: "Saved Skills",
    pageTitle: "Saved Skills",
  },
];

const CareersLayout = ({
  children,
  search,
  setSearch,
  gridType,
  setGridType = Function.prototype,
  sort = "relevance",
  setSort,
  isSkills,
  isCareers,
  loading,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [plan, setPlan] = useState();
  const [planLoading, setLoading] = useState(false);
  const { planDetails } = useOrganization();
  const { t } = useLocalizedTranslation();
  const { navigateCESkills, navigateCECareers } = useRedirect();
  const handleBrowseNavigate = useBrowseNavigate();

  useEffect(() => {
    fetchPlanDetails();
  }, []);

  const fetchPlanDetails = async () => {
    setLoading(true);
    const res = await planDetails();
    setPlan(res);
    setLoading(false);
  };

  const handleSearchResults = (searchValue) => {
    if (!isSkills && !isCareers) navigateCECareers(searchValue);
    setSearch(searchValue);
  };

  const handleClosePopup = () => navigate(location.state ?? -1);

  return (
    <DashboardLayout isPrivate loading={planLoading}>
      <Banner mobHeight="350px">
        <div className="container flex-column items-center text-center pt-2 mt-18 mt-14--mob">
          <h2 className="mx-auto text-center">{t("Career Explorer")}</h2>
          <p className="w-60p w-90p--mob mx-auto fs-15 mt-2">
            {t("bannerMessage")}
          </p>
          <SearchInput
            classes="mx-auto mt-4 maxw-90p"
            height="40px"
            width="600px"
            placeholder={
              "Search for interested career or skill and save to your own list"
            }
            t={t}
            search={search}
            setSearch={handleSearchResults}
            loading={loading}
          />
          <div className="mt-3">
            <Radio
              labelClasses="fs-15"
              size="small"
              name="search"
              options={[
                { key: "careers", value: "Search for a career" },
                { key: "skills", value: "Search for a skill" },
              ]}
              value={isSkills ? "skills" : "careers"}
              onChange={(e) =>
                e.target.value === "skills" && !isSkills
                  ? navigateCESkills()
                  : !isCareers && navigateCECareers()
              }
              t={t}
              disabled={loading}
            />
          </div>
        </div>
      </Banner>
      <BrowseWrapper
        noHeaderFooter
        filters={[FILTER_TYPES.CAREERS, FILTER_TYPES.CAREERS_STATUS]}
        browseMode={0}
        browseOptions={browse_options}
        search={search}
        setSearch={setSearch}
        setBrowseMode={handleBrowseNavigate}
        hidePageTitle
        gridType={gridType}
        setGridType={setGridType}
        setSort={setSort}
        sortOptions={[
          {
            value: "Recent",
            key: "creation_date",
          },
          {
            value: "Relevance",
            key: "relevance",
          },
        ]}
        sort={sort}
        listingTitle={t(
          !isSkills && !isCareers
            ? "Recommendations based on your profile"
            : "Browse Careers and Skills"
        )}
        loading={loading}
        filtersTitle="Advanced Search"
      >
        {children}
      </BrowseWrapper>
      <ModalLayout
        open={!isTrue(plan?.career_explorer)}
        width="min(500px, 95%)"
        top="300px"
        hideCloseIcon
      >
        <div className="px-6 py-6 text-center relative flex-column items-center justify-center">
          <h3 className="mb-6">
            {t(
              "Please purchase the Career Explorer Add On to unlock this feature."
            )}
          </h3>
          <div className="flex justify-between w-full">
            <Button bordered onClick={handleClosePopup}>
              {t("Back", "common")}
            </Button>
            <GetAddonsButton onClose={fetchPlanDetails} />
          </div>
        </div>
      </ModalLayout>
    </DashboardLayout>
  );
};

export default CareersLayout;
